import { cn } from 'util/cn'

import { css } from 'design'
import { Tooltip } from 'primitives/tooltip'
import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  element?: HTMLElement
}

// eslint-disable-next-line
// @ts-ignore
export const ErrorMessage = ({
  element,
  children,
  ...props
}: Props & React.HTMLAttributes<HTMLDivElement>) => {
  const [isOpen, setIsOpen] = useState(false) // used to delay the open to fix tooltip having wrong position sometimes

  useEffect(() => {
    if (element) {
      element.style.position = 'relative'
      setIsOpen(true)
    }
  }, [element])

  const errorMessageElement = (
    <div {...props} className={cn(props.className, styles())}>
      <i className="fas fa-exclamation-triangle" />
      &nbsp;
      {children}
    </div>
  )

  if (element) {
    return createPortal(
      <Tooltip
        tooltip={errorMessageElement}
        open={isOpen}
        className={tooltipStyles()}
      >
        <div className={tooltipAnchorStyles()} />
      </Tooltip>,
      element,
    )
  } else {
    return errorMessageElement
  }
}

const tooltipAnchorStyles = css({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  appearance: 'none',
})

const tooltipStyles = css({
  padding: '0 !important',

  svg: {
    fill: '$red700',
  },
})

const styles = css({
  background: '$red700',
  color: 'white',
  padding: '$2',
  borderRadius: '$2',
  display: 'flex',
  alignItems: 'center',

  i: {
    marginRight: '$1',
  },
})
